import { useQuery } from '@tanstack/react-query'

import { fetchParkingByPlan } from '@/utils/parkingsService'

import { ParkingsPlanParams } from '../parkings'

export const useFetchParkingPlans = ({
  slug,
  params
}: {
  slug: string
  params?: ParkingsPlanParams
}) => {
  return useQuery({
    queryKey: ['parkingPlans', slug, params],
    queryFn: () => fetchParkingByPlan({ slug, params }),
    enabled: !!slug
  })
}
